var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "max-w-3xl mx-auto py-4" }, [
    _c(
      "div",
      { staticClass: "bg-white p-4 rounded-md text-xl flex items-center" },
      [
        _c(
          "svg",
          {
            staticClass: "h-6 w-6 mr-2 text-green-500",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              stroke: "currentColor"
            }
          },
          [
            _c("path", {
              attrs: {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              }
            })
          ]
        ),
        _vm._v(" " + _vm._s(_vm.confirmText) + " ")
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }